module.exports = __webpack_public_path__ + "static/assets/4784a44acaabfcf2432b721583a29eda.svg";